import { endpoint, EndpointError } from 'endpoints/endpoint';
import { Model as SettingsModel } from 'models/settings';

export type GetSettingsParams = void;
export type GetSettingsResult = { data: SettingsModel };
export type GetSettingsError = EndpointError;

export const getSettings = endpoint<GetSettingsParams, GetSettingsResult, GetSettingsError>({
  method: 'GET',
  url: () => '/settings',
});
